import { InputGroup, InputGroupText, Input, Button } from 'reactstrap';
import { Search as SearchIcon, X as ClearIcon } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';

export const Search = ({
  searchKeyword,
  onSearch,
  onClearSearch
}: {
  searchKeyword: string;
  onSearch: (searchTerm: string) => void;
  onClearSearch?: () => void;
}) => {
  const [searchText, setSearchText] = useState('');
  console.log('Search component rendered with searchKeyword:', searchKeyword);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchText((searchKeyword ?? '').trim());
    }, 300);

    return () => clearTimeout(timer);
  }, [searchKeyword]);

  const handleSearch = (value: string) => {
    setSearchText(value);
    if (value.trim().length > 0) {
      setSearchText(value.trim());
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e?.keyCode === 13 && (searchText ?? '').trim().length > 0) {
      onSearch((searchText ?? '').trim());
    }
  };

  const handleClearSearch = () => {
    setSearchText("");
    if (onClearSearch) {
      onClearSearch();
    }
  };

  return (
    <InputGroup className="search-box">
      <InputGroupText>
        <SearchIcon />
      </InputGroupText>
      <Input
        className="search-input"
        placeholder="Search"
        value={searchText}
        onChange={(e) => handleSearch(e.target.value)}
        onKeyDown={(e) => handleKeyDown(e)}
      />
      {(searchKeyword ?? '').trim().length > 0 && (
        <Button
          className="clear-button"
          color="light"
          onClick={handleClearSearch}
        >
          <ClearIcon />
        </Button>
      )}
    </InputGroup>
  );
};
